const _constant = {};

/* ---------------- Native Api  ----------------*/

_constant.PPBL = 'PPBL';
_constant.POSTPAID = 'PAYTM_DIGITAL_CREDIT';
_constant.CC = 'CREDIT_CARD';
_constant.DC = 'DEBIT_CARD';
_constant.NB = 'NET_BANKING';
_constant.EMI = 'EMI';
_constant.UPI = 'UPI';
_constant.AOA = 'WALLET';
_constant.UPI_INTENT = 'UPI_INTENT';
_constant.UPI_PUSH = 'UPI_PUSH';
_constant.WALLET = 'BALANCE';
_constant.GIFT_VOUCHER = 'GIFT_VOUCHER';
_constant.COD = 'COD';
_constant.NATIVE = 'NATIVE';
_constant['3D'] = '3D';
_constant.NONE = 'NONE';
_constant.PIN = 'pin';
_constant.OTP = 'otp';
_constant.ATM = 'atm';
_constant.USRPWD = 'USRPWD';
_constant.WAP = 'WAP';
_constant.WEB = 'WEB';
_constant.ADA = 'ADVANCE_DEPOSIT_ACCOUNT';
_constant.UPIPUSH = 'UPIPUSH';
_constant.UPIPUSHEXPRESS = 'UPIPUSHEXPRESS';
_constant.QR_PRN = 'QR_PRN';
_constant.SUBMIT = 'SUBMIT';
_constant.UPDATE_PAYLOAD = 'UPDATE_PAYLOAD';
_constant.GET_TXN_TOKEN_PAYLOAD = 'GET_TXN_TOKEN_PAYLOAD';
_constant.SUBMIT_WITH_TOKEN = 'SUBMIT_WITH_TOKEN';
_constant.PAY_SUCCESS = 'paysuccess';
_constant.PAY_FAIL = 'payfail';
_constant.SESSION_EXPIRED = 'sessionExpired';
_constant.TXN_TOKEN_EXPIRED = 'txnTokenExpired';
_constant.GENERIC_ERROR = 'Something went wrong';
_constant.PROCESSING = 'Processing';
_constant.CUSTOM_PROCESSING = 'CUSTOM_PROCESSING';
_constant.RETRY = 'Retry';
_constant.TXN_AMOUNT = 'TXN_AMOUNT';
_constant.FALLBACK_TXN_AMOUNT = 'FALLBACK_TXN_AMOUNT';
_constant.WITHOUT_PCF_TXN_AMOUNT = 'WITHOUT_PCF_TXN_AMOUNT';
_constant.UNMODIFIED_TXN_AMOUNT = 'UNMODIFIED_TXN_AMOUNT';
_constant.SHOW_PROCESSING = 'showProcessing';
_constant.HEADER = 'header';
_constant.FOOTER = 'footer';
_constant.OFFERS = 'offers';
_constant.STATIC = 'static';
_constant.LOGIN = 'LOGIN';
_constant.OPEN_POPUP_WINDOW = 'OPEN_POPUP_WINDOW';
_constant.POPUP_WINDOW = 'POPUP_WINDOW';
_constant.IS_DIRECT_BANK = 'IS_DIRECT_BANK';
_constant.IS_SELF_CLOSE = 'IS_SELF_CLOSE';
_constant.HIDE_PROCESSING = 'hideProcessing';
_constant.CLIENT_VALIDATION = 'clientValidation';
_constant.INITIALIZED = 'initialized';
_constant.HIDECN = 'hideCN';
_constant.HIDECVVEXPIRY = 'hideCVVExpiry';
_constant.SHOW_EMI_PLAN_LIST = 'showEmiPlan';
_constant.HIDE_EMI_PLAN_LIST = 'hideEmiPlan';
_constant.SHOW_SAVED_CARD_AND_PLAN = 'showSavedCardAndPlan';
_constant.HIDE_SAVED_CARD_AND_PLAN = 'hideSavedCardAndPlan';
_constant.CARD_NOT_SUPPORTED = 'cardNotSupported';
_constant.HIDE_RING_LODER = 'HIDE_RING_LODER';
_constant.LOG_CARD_DETAILS = 'LOG_CARD_DETAILS';
_constant.REMOVE_CARD_NUMBER = 'REMOVE_CARD_NUMBER';
_constant.CARD_DETAILS_RESOLVED = 'cardDetailsResolved';
_constant.MID = 'MID';
_constant.ORDER_ID = 'ORDER_ID';
_constant.CARD_DETAILS = 'cardDetails';
_constant.SUBSCRIPTION = 'Subscription';
_constant.UPDATE_HEIGHT = 'UPDATE_HEIGHT';
_constant.HANDLE_PROMO_RESPONSE = 'handlePromoResponse';
_constant.SC = 'SC';
_constant.CARD_AND_DEBIT = 'Debit / Credit Cards';
_constant.DEFAULT_INSTANCE_KEY = 'DEFAULT';
_constant.IS_LINK_TXN = 'IS_LINK_TXN';
_constant.IS_UPI_TXN = 'IS_UPI_TXN';
_constant.TIMEOUT_ID = 'TIMEOUT_ID';
_constant.INTERVAL_ID = 'INTERVAL_ID';
_constant.IS_BANKPAGE_REQUIRED_BLOCKED = 'IS_BANKPAGE_REQUIRED_BLOCKED';
_constant.MGV = 'MGV';
_constant.NOTIFY_MERCHANT = 'NOTIFY_MERCHANT';
_constant.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW = 'IS_EMISUBVENTION_ACCESS_TOKEN_FLOW';
_constant.EMISUBVENTION_STATEGY = 'EMISUBVENTION_STATEGY';
_constant.SUBVENTION_OBJ = 'SUBVENTION_OBJ';
_constant.SUBVENTION_OBJ_INITIAL = 'SUBVENTION_OBJ_INITIAL';
_constant.SUBVENTION_MINI_CART_OBJ = 'SUBVENTION_MINI_CART_OBJ';
_constant.CACHE_CARD_TOKEN = 'cacheCardToken';
_constant.WEB_VIEW_FLOW = 'WEB_VIEW_FLOW';
_constant.SUBS_PAYMODE_MIN_AMOUNT = '1';
_constant.BM = 'BANK_MANDATE';
_constant.SBM = 'SAVED_BANK_MANDATE';
_constant.EMISUBVENTION_TOKEN = 'EMISUBVENTION_TOKEN';
_constant.PAYMODE_BASED_OFFER = 'PAYMODE_BASED_OFFER';
_constant.SET_VALIDATION_STATUS = 'SET_VALIDATION_STATUS';
_constant.IS_IN_POLLING_STATUS = 'IS_IN_POLLING_STATUS';
_constant.ALLOWED_MERCHANT_RETRY_COUNTS = 'ALLOWED_MERCHANT_RETRY_COUNTS';
_constant.CVV_EXPIRY_FOCUS = 'CVV_EXPIRY_FOCUS';
_constant.SAVED_PAYMODES = 'SAVED_PAYMODES';
_constant.IS_LOGGED_IN = 'IS_LOGGED_IN';
_constant.IS_LOCAL_STORAGE_ALLOWED = 'IS_LOCAL_STORAGE_ALLOWED';
_constant.CURRENT_PAYMODE = 'CURRENT_PAYMODE';
_constant.MOBILE_NO = 'MOBILE_NO';
_constant.CARD_TYPE = 'CARD_TYPE';
_constant.STORAGE_USED = 'STORAGE_USED';
_constant.FOUND_LAST_USED_PAYMODE = 'FOUND_LAST_USED_PAYMODE';
_constant.CARD_NUMBER_RESET = 'CARD_NUMBER_RESET';
_constant.BANK_OFFER_TXN_AMOUNT = 'BANK_OFFER_TXN_AMOUNT';
_constant.ICON_BASE_URL = 'ICON_BASE_URL';
_constant.IS_UPI_APPS_PAYMODE_ENABLED = 'IS_UPI_APPS_PAYMODE_ENABLED';
_constant.IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS = 'IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS';

_constant.DEFERRED_EVENTS = {
  FETCH_PAYMODE: 'FETCH_PAYMODE',
  FETCH_EMI_PLANS: 'FETCH_EMI_PLANS',
  FETCH_EMI_BANK_DETAILS: 'FETCH_EMI_BANK_DETAILS',
  FETCH_CARD_DETAILS: 'FETCH_CARD_DETAILS',
  APPLY_EMI: 'APPLY_EMI',
  INITIATE_TXN: 'INITIATE_TXN',
  POST_CART: 'POST_CART'
};
_constant.HELPER_TYPE = {
  CVV_HELPER: 'CVV_HELPER',
  SUBS_DETAILS_HELPER: 'SUBS_DETAILS_HELPER'
};

// QR
_constant.QR = {
  WS: '/websocket/',
  QR_HOST
};

// emi type constants
_constant.EMI_STANDARD = 'STANDARD';
_constant.EMI_SUBVENTION = 'SUBVENTION';

_constant.NOTIFY_MERCHANT_EVENTS = {
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  FETCH_PAYMENT_OPTIONS_ERROR: 'FETCH_PAYMENT_OPTIONS_ERROR',
  HANDLER_ERROR: 'HANDLER_ERROR',
  FETCH_EMI_BANK_LIST_ERROR: 'FETCH_EMI_BANK_LIST_ERROR',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  APP_CLOSED: 'APP_CLOSED'
};
_constant.SUBS_TYPE = {
  VARIABLE: 'VARIABLE'
};

_constant.BANK_MANDATE_PAY_TYPE = 'bm';
_constant.SAVED_BANK_MANDATE_PAY_TYPE = 'sbm';

/** ********** Bank account constraints ********* */
_constant.ACCOUNT_NAME_MAX_LENGTH = 50;
_constant.ACCOUNT_NUMBER_MAX_LENGTH = 19;
_constant.ACCOUNT_IFSC_LENGTH = 11;
_constant.ACCOUNT_NAME_MIN_LENGTH = 3;
_constant.ACCOUNT_NUMBER_MIN_LENGTH = 9;

/** ********** Bank Mandate Authenticate Modes ************ */
_constant.MANDATE_AUTH_MODES = { NET_BANKING: 'Net Banking', DEBIT_CARD: 'Debit Card' };
_constant.NB_AUTH_MODE = 'NET_BANKING';

export const CACHE = {
  MERCHANT_CONFIG: 'merchantConfig',
  API: 'api',
  STORE: 'store',
  PAYMENT_OPTIONS: 'paymentOptions',
  EMI_BANK_LIST: 'emiBankList',
  TOKEN_DATA: 'tokenData',
  GUEST_TOKEN: 'guestToken',
  FALLBACK_TOKEN_DATA: 'fallbackTokenData',
  PLAN_DETAILS: 'planDetails',
  PAYMENT_INTENT: 'paymentIntent',
  EMI_PLANS: 'emiPlans',
  SELECTEDBANK: 'selectedBank',
  CARD_DETAILS: 'cardDetails',
  ORDER_ID: 'orderId',
  RAW_INSTRUMENTS: 'rawPayData',
  DEFERRED_POPUP_DATA: 'deferredPopupData',
  CONVENIENCE_CHARGES: 'convenienceCharges',
  CLOSE_HANDLER: 'closeHandler',
  BANK_OFFERS: 'bankOffers',
  ALL_BANK_OFFERS: 'allBankOffers',
  MID: 'mid',
  ACCESS_TOKEN: 'accessToken',
  RETRY_DATA: 'RETRY_DATA',
  PAYMENT_OFFERS: 'PAYMENT_OFFERS',
  GLOBAL_STORE_UNSUBSCRIPTION: 'GLOBAL_STORE_UNSUBSCRIPTION',
  CHECKOUT_ELEMENT_PAYMODE: 'CHECKOUT_ELEMENT_PAYMODE'
};

export const EVENTS = {
  DEFERRED_FLOW_INITIALIZED: 'DEFERRED_FLOW_INITIALIZED',
  SC_EMI_FETCH_PLANS: 'SC_EMI_FETCH_PLANS',
  SC_EMI_FETCH_PLANS_ERROR: 'SC_EMI_FETCH_PLANS_ERROR',
  EMI_FETCH_BANK: 'EMI_FETCH_BANK',
  EMI_FETCH_BANK_ERROR: 'EMI_FETCH_BANK_ERROR',
  EMI_FETCH_PLANS: 'EMI_FETCH_PLANS',
  EMI_FETCH_PLANS_ERROR: 'EMI_FETCH_PLANS_ERROR',
  EMI_APPLY_PLAN: 'EMI_APPLY_PLAN',
  EMI_APPLY_PLAN_ERROR: 'EMI_APPLY_PLAN_ERROR',
  SC_EMI_APPLY_PLAN: 'SC_EMI_APPLY_PLAN',
  SC_EMI_APPLY_PLAN_ERROR: 'SC_EMI_APPLY_PLAN_ERROR',
  DEFERRED_INITIATE_TXN: 'DEFERRED_INITIATE_TXN',
  DEFERRED_INITIATE_TXN_ERROR: 'DEFERRED_INITIATE_TXN_ERROR',
  ACCESS_TOKEN_FLOW_INITIALISED: 'ACCESS_TOKEN_FLOW_INITIALISED',
  ACCESS_TOKEN_INITIATE_TXN: 'ACCESS_TOKEN_INITIATE_TXN'
};

export const RESPONSE_STATUS = {
  SUCCESS: 'SUCCESS',
  PROCESSING: 'PROCESSING',
  TXN_SUCCESS: 'TXN_SUCCESS',
  FAIL: 'FAIL',
  REDIRECT: 'REDIRECT',
  F: 'F',
  S: 'S'
};

export const RESPONSE_STATUS_CODE = {
  SUCCESS: 200
};

export const UPI_INTENT_MWEB = {
  UPI_INTENT: 'UPI_INTENT',
  UPI_INTENT_MWEB: 'UPI_INTENT_MWEB',
  VISIBILITY_HIDDEN_VALUE: 'VISIBILITY_HIDDEN_VALUE',
  IS_UPI_INTENT_MWEB_ENABLED: 'IS_UPI_INTENT_MWEB_ENABLED'
};

export const GLOBAL_STORE = {
  FPO_UPDATED_RESPONSE: 'FPO_UPDATED_RESPONSE'
};

export default _constant;



// WEBPACK FOOTER //
// ./utils/constants.js